import type React from 'react';
// import styles from './Home.module.scss';

const NotFound: React.FC = () => {
  return (
    <div>404</div>
  );
};

export default NotFound;
